export enum AccountingStatus {
	STORNIERT = "Storniert",
	BEZAHLT = "Bezahlt",
	TELIZAHLUNG = "Teilzahlung",
	OFFEN = "Offen",
}
